import { BaseEvent } from '~/app/tracking/events/base-event';
import { EventAction } from '~/app/tracking/feld-m-types';

export type DeclineConflictParams = {
	element: 'declineButton' | 'closeButton';
};

const declineOptions: { [key: string]: { eventName: string; clickID: string; elementName: string } } = {
	declineButton: {
		eventName: 'decline configuration change',
		clickID: 'decline',
		elementName: 'button',
	},
	closeButton: {
		eventName: 'close layer',
		clickID: 'x',
		elementName: 'icon',
	},
};

export class DeclineConflict extends BaseEvent {
	constructor({ element }: DeclineConflictParams) {
		super({
			eventInfo: {
				eventAction: EventAction.InternalLink,
				eventName: `configuration assistant - click to ${declineOptions[element].eventName}`,
			},
			attributes: {
				componentName: 'configuration-assistant',
				clickID: `click on ${declineOptions[element].clickID}`,
				elementName: declineOptions[element].elementName,
			},
			additionalObjects: {
				componentInfo: {
					componentID: 7,
				},
				attributes: {
					implementer: 1,
					version: '1.0.0',
				},
				page: {
					pageInfo: {
						pageID: `configuration assistant - conflict layer`,
					},
				},
			},
		});
	}
}
